export const enum IllustratorArtType {
    /** Special type never returned as an art object type, but used
		as a parameter to the Matching Art suite function \c #AIMatchingArtSuite::GetMatchingArt(). */
	Any = -1,

	/** Reserved for objects that are not supported in the plug-in interface.
		You should anticipate unknown art objects and ignore them gracefully.
		If a plug-in written for an earlier version of the plug-in API calls
		\c #AIArtSuite::GetArtType() with an art object of a type unknown in its version,
		the function maps the type to either an appropriate type or to \c kUnknownArt. */
	Unknown = 0,

	/**  Art group */
	Group = 1,

	/**  Path art */
	Path = 2,

	/**  Compound path art */
	CompoundPath = 3,

	/** Pre-AI11 text art type; no longer supported but remains as a place holder so
		that the values for other art types remain the same. */
	TextArtUnsupported = 4,

	/** Pre-AI11 text art type; no longer supported but remains as a place holder so
		that the values for other art types remain the same. */
	TextPathArtUnsupported = 5,

	/** Pre-AI11 text art type; no longer supported but remains as a place holder so
		that the values for other art types remain the same. */
	TextRunArtUnsupported = 6,

	/**  Placed art */
	PlacedArt = 7,

	/** Never returned as an art object type, it is
		an obsolete parameter to \c #AIMatchingArtSuite::GetMatchingArt().
		It was used to match paths inside text objects without matching the text objects themselves.
		In AI11 and later, use the \c kMatchTextPaths flag to return text paths. */
	MysteryPathArt = 8,

	/**  Raster art */
	RasterArt = 9,

	/**  Plug-in art */
	PluginArt = 10,

	/**  Mesh art */
	MeshArt = 11,

	/**  Text Frame art */
	TextFrameArt = 12,

	/**  Symbol art */
	SymbolArt = 13,

	/** A foreign object, which is a "black box" containing drawing commands, constructed with
		\c #AIForeignObjectSuite::New() rather than \c #AIArtSuite::NewArt(). */
	ForeignArt = 14,

	/** A text object read from a legacy file (AI10 or earlier) */
	LegacyTextArt = 15,

	/** Chart Art (Deprecated) */
	ChartArt = 16,

    /** Radial Repeat Art */
    RadialRepeatArt = 17,

    /** Grid Repeat Art */
    GridRepeatArt = 18,

    /** Symmetry Art */
    SymmetryArt = 19,

    /** Concentric Repeat Art */
    ConcentricRepeatArt = 20,
}

export const enum IllustratorColorType {
    None = -1,
    Cmyk = 0,
    CustomColour = 1,
    Rgb = 2,
    Grey = 3,
    Lab = 4,
    Pattern = 5,
    Gradient = 6,
}

export const enum IllustratorJustifcation {
    Left = 0,
    Right = 1,
    Center = 2,
    FullJustifyLastLineLeft = 3,
    FullJustifyLastLineRight = 4,
    FullJustifyLastLineCenter = 5,
    FullJustifyLastLineFull = 6,
}

export const enum IllustratorTextType {
    Unknown = -1,
    PointText = 0,
    InPathText = 1,
    OnPathText = 2,
}
